import env from '@/utils/constants';

export const version = env.VITE_APP_VERSION ?? 'dev';
